import { Link } from 'react-router-dom';
import type { Crumb } from './Breadcrumb';

interface PageBannerProps {
  kicker?: string;
  title: string;
  subtitle?: string;
  crumbs: Crumb[];
  image?: string;
}

export default function PageBanner({ kicker, title, subtitle, crumbs, image }: PageBannerProps) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-800 via-primary-900 to-primary-950">
      {image ? (
        <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" />
      ) : null}
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 to-transparent"></div>
      <div className="relative mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14 lg:px-8">
        <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-background-50/60 md:text-sm">
          {crumbs.map((item, index) => {
            const isLast = index === crumbs.length - 1;
            return (
              <span key={`${item.label}-${index}`} className="inline-flex items-center gap-1.5">
                {item.to && !isLast ? (
                  <Link to={item.to} className="cursor-pointer transition-colors hover:text-background-50">
                    {item.label}
                  </Link>
                ) : (
                  <span className={isLast ? 'text-accent-300' : ''}>{item.label}</span>
                )}
                {!isLast ? <i className="ri-arrow-right-s-line text-background-50/40"></i> : null}
              </span>
            );
          })}
        </nav>

        {kicker ? (
          <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-label font-medium tracking-widest text-accent-300">
            <i className="ri-shining-2-line"></i>
            {kicker}
          </span>
        ) : null}
        <h1 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-4xl">{title}</h1>
        {subtitle ? <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-50/75 md:text-base">{subtitle}</p> : null}
      </div>
    </section>
  );
}